
import storyblok from '~/mixins/storyblok'

import IAutonome from '~/components/svg/Autonome'
import IDurable from '~/components/svg/Durable'
import IImpact from '~/components/svg/Impact'
import ILocal from '~/components/svg/Local'
import IPositif from '~/components/svg/Positif'

export default {
  name: 'APropos',
  components: { IAutonome, IDurable, IImpact, ILocal, IPositif },
  mixins: [storyblok],
  async asyncData({ $db, $storyblok, error, params }) {
    const story = await $storyblok.getStoryBySlug('a-propos')
    return { ...story.body[0], storyId: story.id }
  },
  computed: {
    cardKeys() {
      return ['positif', 'autonome', 'local', 'impact', 'durable']
    },
    cardIcons() {
      return {
        autonome: 'IAutonome',
        durable: 'IDurable',
        impact: 'IImpact',
        local: 'ILocal',
        positif: 'IPositif'
      }
    }
  },
  mounted() {
    this.listenStoryblokChanges(this.storyId, (event) => {
      Object.keys(event.story.content.body[0]).forEach((key) => {
        this[key] = event.story.content.body[0][key]
      })
    })
  },
  head() {
    return {
      title: "Grand'Rue augmente et simplifie le commerce local !"
    }
  }
}
